// ============================================================================
// UNIVERSAL ACTION HANDLERS - LINKING ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";

/**
 * Linking Actions - Link contacts to companies and vice versa
 */
export const linkingActions: UniversalActionHandlers = {
  // Link contact to company (from company detail page)
  linkContact: async (item, context) => {
    context.onOpenModal("link-contact", {
      companyId: item.id,
      companyName: item.name,
      item,
    });
  },

  // Link company to contact (from contact detail page)
  linkCompany: async (item, context) => {
    context.onOpenModal("link-company", {
      contactId: item.id,
      contactName: item.name,
      currentCompanyId: item.company_id,
      currentCompanyName: item.company_name,
      item,
    });
  },
};
